export enum BookType {
    book = 1,
    playbook = 2,
}export enum BookType {
    book = 1,
    playbook = 2,
}